import { motion } from "motion/react";
import type { ShowcasePanel } from "@/src/constants/product-showcase";

export function ShowcasePanelFull({ panel }: { panel: ShowcasePanel }) {
    return (
        <div className="relative h-[85vh] overflow-hidden">
            <motion.div
                initial={{ scale: 1.05 }}
                whileInView={{ scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 1.5 }}
                className="absolute inset-0"
            >
                <img
                    src={panel.image}
                    alt={panel.catchphrase}
                    className="w-full h-full object-cover brightness-[0.45]"
                    referrerPolicy="no-referrer"
                />
            </motion.div>
            <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.3 }}
                className="absolute inset-0 flex items-center justify-center text-white text-center px-6"
            >
                <div className="max-w-3xl">
                    <h2 className="font-serif text-5xl md:text-7xl font-light italic mb-6 leading-tight">
                        {panel.catchphrase}
                    </h2>
                    <p className="text-base md:text-lg font-light opacity-75 leading-relaxed max-w-xl mx-auto">
                        {panel.body}
                    </p>
                </div>
            </motion.div>
        </div>
    );
}
